import React from "react";
import { values } from "./values";

export const Valores = () => (
    <section
        id="valores"
        className="lf-bg-soft py-20 sm:py-24"
        data-testid="valores-section"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto mb-14">
                <span
                    className="text-xs font-semibold uppercase tracking-[0.22em]"
                    style={{ color: "var(--lf-green-dark)" }}
                >
                    Principios rectores
                </span>
                <h2
                    className="mt-3 text-3xl sm:text-4xl font-bold lf-text-blue leading-tight"
                    data-testid="valores-heading"
                >
                    Nuestros Valores
                </h2>
                <div className="flex justify-center mt-5 mb-6">
                    <div className="lf-gold-divider" />
                </div>
                <p
                    className="lf-text-mute text-base sm:text-lg leading-relaxed"
                    data-testid="valores-subtitle"
                >
                    La Lotería del Estado Falcón se rige por los siguientes
                    valores, que inspiran y orientan su accionar diario en pro
                    del bienestar colectivo.
                </p>
            </div>

            <div className="grid gap-6 sm:gap-7 sm:grid-cols-2 md:grid-cols-3">
                {values.map((v, idx) => {
                    const Icon = v.Icon;
                    const chipClass =
                        v.tone === "gold"
                            ? "lf-icon-chip lf-icon-chip-gold"
                            : "lf-icon-chip";
                    return (
                        <article
                            key={v.title}
                            className="lf-card p-6 sm:p-7"
                            data-testid={`valor-card-${idx}`}
                        >
                            <div className="flex items-start gap-4">
                                <div className={chipClass}>
                                    <Icon size={24} strokeWidth={2} />
                                </div>
                                <div className="flex-1">
                                    <h3
                                        className="text-lg font-bold lf-text-blue leading-snug"
                                        data-testid={`valor-title-${idx}`}
                                    >
                                        {v.title}
                                    </h3>
                                    <p
                                        className="mt-2 text-sm leading-relaxed lf-text-mute"
                                        data-testid={`valor-description-${idx}`}
                                    >
                                        {v.description}
                                    </p>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
        </div>
    </section>
);
